/* eslint-disable @typescript-eslint/no-explicit-any */
import { addDays, addMonths, subDays, subMonths } from 'date-fns';
import { useCallback, useContext } from 'react';
import { ConfigContext } from '../../context';

//TODO rename to useDateRange or something similar as this is not only for last dates but also for next dates
export enum LastDateValue {
  LAST_24_HRS = 'LAST_24_HRS',
  LAST_7_DAYS = 'LAST_7_DAYS',
  LAST_30_DAYS = 'LAST_30_DAYS',
  LAST_3_MONTHS = 'LAST_3_MONTHS',
  LAST_6_MONTHS = 'LAST_6_MONTHS',
  LAST_12_MONTHS = 'LAST_12_MONTHS',
  ALL_TIME = 'ALL_TIME',
  NEXT_24_HRS = 'NEXT_24_HRS',
  NEXT_7_DAYS = 'NEXT_7_DAYS',
  NEXT_30_DAYS = 'NEXT_30_DAYS',
  NEXT_3_MONTHS = 'NEXT_3_MONTHS',
  NEXT_6_MONTHS = 'NEXT_6_MONTHS',
  NEXT_12_MONTHS = 'NEXT_12_MONTHS',
}

export const useLastDate = () => {
  const { allTimeStartDate } = useContext(ConfigContext).config.elements.dateRangeFilter;

  const isLastDate = (value: any) => Boolean(Object.values(LastDateValue).includes(value));

  const getLastDate = useCallback(
    (value: LastDateValue) => {
      const date = new Date();

      date.setSeconds(0, 0);

      const to = date.toISOString();

      switch (value) {
        case LastDateValue.LAST_24_HRS:
          return { from: subDays(date, 1).toISOString(), to };
        case LastDateValue.LAST_7_DAYS:
          return { from: subDays(date, 7).toISOString(), to };
        case LastDateValue.LAST_30_DAYS:
          return { from: subDays(date, 30).toISOString(), to };
        case LastDateValue.LAST_3_MONTHS:
          return { from: subMonths(date, 3).toISOString(), to };
        case LastDateValue.LAST_6_MONTHS:
          return { from: subMonths(date, 6).toISOString(), to };
        case LastDateValue.LAST_12_MONTHS:
          return { from: subMonths(date, 12).toISOString(), to };
        case LastDateValue.ALL_TIME:
          return { from: new Date(allTimeStartDate).toISOString(), to };
        case LastDateValue.NEXT_24_HRS:
          return { from: to, to: addDays(date, 1).toISOString() };
        case LastDateValue.NEXT_7_DAYS:
          return { from: to, to: addDays(date, 7).toISOString() };
        case LastDateValue.NEXT_30_DAYS:
          return { from: to, to: addDays(date, 30).toISOString() };
        case LastDateValue.NEXT_3_MONTHS:
          return { from: to, to: addMonths(date, 3).toISOString() };
        case LastDateValue.NEXT_6_MONTHS:
          return { from: to, to: addMonths(date, 6).toISOString() };
        case LastDateValue.NEXT_12_MONTHS:
          return { from: to, to: addMonths(date, 12).toISOString() };
        default:
          return { from: null, to: null };
      }
    },
    [allTimeStartDate]
  );

  const getDateRange = useCallback(
    (dateRange: any) => {
      const date = isLastDate(dateRange) ? getLastDate(dateRange) : { ...dateRange };

      const { from = null, to = null } = { ...date };

      return { ...(from && { from }), ...(to && { to }) };
    },
    [getLastDate]
  );

  return { isLastDate, getLastDate, getDateRange };
};
